module.exports = "https://static.wagwalking.com/_next/static/images/become-a-walker-banner-walkers-52cf9fb02d377043488ffe896f43e6c8.png";